import {
  BookTypePills,
} from '../../../shared/bookTypePills';
import { allCountryTaxes } from '../constants';
import initialState from './initialState';
import {
  FETCHING_SL_GROUPS_INITIAL_DATA,
  FETCHING_SL_GROUPS_INITIAL_DATA_SUCCESS,
  FETCHING_SL_GROUPS_INITIAL_DATA_FAILURE,
  FETCHING_SL_GROUP_ITEMS,
  FETCHING_SL_GROUP_ITEMS_SUCCESS,
  FETCHING_SL_GROUP_ITEMS_FAILURE,
  CHANGE_SL_GROUP_TYPE,
  CHANGE_SL_GROUP_ITEM,
  CHANGE_PERIOD_FROM,
  CHANGE_PERIOD_TO,
  FETCHING_COUNTRY_TAX_TYPES,
  FETCHING_COUNTRY_TAX_TYPES_SUCCESS,
  FETCHING_COUNTRY_TAX_TYPES_FAILURE,
  CHANGE_COUNTRY_TAX_TYPE,
  FETCHING_REPORT_DATA_FOR_GROUP,
  FETCHING_REPORT_DATA_FOR_GROUP_SUCCESS,
  FETCHING_REPORT_DATA_FOR_GROUP_FAILURE,
  CHANGE_BOOK_TYPE,
  FETCHING_REPORTING_CURRENCY_CODES_FOR_GROUP,
  FETCHING_REPORTING_CURRENCY_CODES_FOR_GROUP_SUCCESS,
  FETCHING_REPORTING_CURRENCY_CODES_FOR_GROUP_FAILURE,
} from './types';

const sortByBookTypePills = (bookTypeA, bookTypeB) => {
  const indexA = BookTypePills.findIndex(({ type }) => type === bookTypeA);
  const indexB = BookTypePills.findIndex(({ type }) => type === bookTypeB);

  return indexA - indexB;
};

const getNewCountryTaxTypeValue = ({ currentCTT, payloadCTT, newCTTs }) => {
  const isCurrentCTTValid = newCTTs.some(
    ({ countryTaxType }) => countryTaxType === (currentCTT && currentCTT.value)
  );
  if (payloadCTT) {
    return payloadCTT;
  }
  if (isCurrentCTTValid) {
    return currentCTT;
  }
  return allCountryTaxes;
};

const slGroupsReducer = (state = initialState, { type, ...payload }) => {
  switch (type) {
    case FETCHING_SL_GROUPS_INITIAL_DATA:
      return {
        ...state,
        isFetchingSlGroupTypes: true,
        isFetchingSlGroupItems: true,
        isFetchingCountryTaxTypes: true,
        isFetchingReportData: true,
      };
    case FETCHING_SL_GROUPS_INITIAL_DATA_SUCCESS: {
      const newCTTs = payload.countryTaxTypes || initialState.countryTaxTypes;
      const newCTT = getNewCountryTaxTypeValue({
        currentCTT: state.countryTaxType,
        payloadCTT: payload.countryTaxType,
        newCTTs,
      });

      return {
        ...state,
        slGroupTypes: payload.slGroupTypes,
        slGroupType: payload.slGroupType || initialState.slGroupType,
        slGroupItems: payload.slGroupItems,
        slGroupItem: payload.slGroupItem || initialState.slGroupItem,
        countryTaxTypes: newCTTs,
        countryTaxType: newCTT,
        bookTypes: payload.bookTypes.sort(sortByBookTypePills) || initialState.bookTypes,
        currencyCode: payload.currencyCode || initialState.currencyCode,
        isFetchingSlGroupTypes: false,
        isFetchingSlGroupItems: false,
        isFetchingCountryTaxTypes: false,
        isFetchingReportData: false,
      };
    }
    case FETCHING_SL_GROUPS_INITIAL_DATA_FAILURE:
      return {
        ...initialState,
      };
    case FETCHING_SL_GROUP_ITEMS:
      return {
        ...state,
        isFetchingSlGroupItems: true,
      };
    case FETCHING_SL_GROUP_ITEMS_SUCCESS:
      return {
        ...state,
        slGroupItems: payload.slGroupItems,
        isFetchingSlGroupItems: false,
      };
    case FETCHING_SL_GROUP_ITEMS_FAILURE:
      return {
        ...state,
        slGroupItems: initialState.slGroupItems,
        isFetchingSlGroupItems: false,
      };
    case CHANGE_SL_GROUP_TYPE:
      return {
        ...state,
        slGroupType: payload.slGroupType,
        slGroupItem: initialState.slGroupItem,
        countryTaxType: initialState.countryTaxType,
      };
    case CHANGE_SL_GROUP_ITEM:
      return {
        ...state,
        slGroupItem: payload.slGroupItem,
        countryTaxTypes: initialState.countryTaxTypes,
        countryTaxType: initialState.countryTaxType,
        isFetchingCountryTaxTypes: true,
      };
    case CHANGE_PERIOD_FROM:
      return {
        ...state,
        periodFrom: payload.periodFrom,
      };
    case CHANGE_PERIOD_TO:
      return {
        ...state,
        periodTo: payload.periodTo,
      };
    case FETCHING_COUNTRY_TAX_TYPES:
      return {
        ...state,
        isFetchingCountryTaxTypes: true,
      };
    case FETCHING_COUNTRY_TAX_TYPES_SUCCESS: {
      const newCTTs = payload.countryTaxTypes || initialState.countryTaxTypes;
      const newCTT = getNewCountryTaxTypeValue({
        currentCTT: state.countryTaxType,
        newCTTs,
      });
      return {
        ...state,
        countryTaxTypes: newCTTs,
        countryTaxType: newCTT,
        isFetchingCountryTaxTypes: false,
      };
    }
    case FETCHING_COUNTRY_TAX_TYPES_FAILURE:
      return {
        ...state,
        countryTaxTypes: initialState.countryTaxTypes,
        isFetchingCountryTaxTypes: false,
      };
    case CHANGE_COUNTRY_TAX_TYPE:
      return {
        ...state,
        countryTaxType: payload.countryTaxType,
        currencyCode: initialState.currencyCode,
        bookTypes: initialState.bookTypes,
        bookType: initialState.bookType,
      };
    case FETCHING_REPORT_DATA_FOR_GROUP:
      return {
        ...state,
        isFetchingReportData: true,
      };
    case FETCHING_REPORT_DATA_FOR_GROUP_SUCCESS: {
      const newBookTypes = payload.bookTypes.sort(sortByBookTypePills);

      return {
        ...state,
        currencyCode: payload.currencyCode,
        bookTypes: newBookTypes,
        bookType: newBookTypes && newBookTypes.length ? newBookTypes[0] : initialState.bookType,
        isFetchingReportData: false,
      };
    }
    case FETCHING_REPORT_DATA_FOR_GROUP_FAILURE:
      return {
        ...state,
        currencyCode: initialState.currencyCode,
        bookTypes: initialState.bookTypes,
        bookType: initialState.bookType,
        isFetchingReportData: false,
      };
    case CHANGE_BOOK_TYPE:
      return {
        ...state,
        bookType: payload.bookType,
      };
    case FETCHING_REPORTING_CURRENCY_CODES_FOR_GROUP:
      return {
        ...state,
        isFetchingReportingCurrencyCodes: true,
      };
    case FETCHING_REPORTING_CURRENCY_CODES_FOR_GROUP_SUCCESS:
      return {
        ...state,
        reportingCurrencyCodes: payload.reportingCurrencyCodes,
        isFetchingReportingCurrencyCodes: false,
      };
    case FETCHING_REPORTING_CURRENCY_CODES_FOR_GROUP_FAILURE:
      return {
        ...state,
        isFetchingReportingCurrencyCodes: false,
      };
    default:
      return state;
  }
};

export default slGroupsReducer;
